import axios from 'axios';
import utils from 'utils/utils';
import history from '../history';

let axiosConfig = {
	headers: {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*'
	}
};
let handleError = (e) => {
	let response = e.response || {};
	let status = response.status;
	if (status === 403) {
		console.log('User is not authorized for API');
	}
	if (status === 401) {
		console.log('User Logged Out');
		// window.f7.loginScreen.open('#LoginPopup');
		// window.popupController.show(Login, {});
		console.log(window.location.pathname);
		if (window.location.pathname.indexOf('/login') === -1) {
			history.navigate('/login?return-url=' + encodeURIComponent(window.location.pathname));
		}
	} else if (status === 404) {
		//do nothing
	}
	console.log('ERROR', e, status, response);
	// throw new Error(e);
	// requests.fireErrors(response);
};

let pre = window.location.origin;

if (pre === 'file://') {
	pre = 'https://api.logrx.com';
}
pre = pre + '/api/v1/';

const CancelToken = axios.CancelToken;

let cancelRequest = (cancel) => {
	setTimeout(() => {
		cancel();
	}, 20000);
};

export const serialize = (obj) => {
	const str = [];
	for (const p in obj)
		if (obj.hasOwnProperty(p)) {
			if (typeof obj[p] === 'object') {
				str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
			} else {
				str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
			}
		}
	return str.join('&');
};

export default () => {
	return {
		get: (url, data) => {
			data = data || {};
			data.token = localStorage.token;
			url += '?' + serialize(data);
			if (!localStorage.last_log_in) localStorage.last_log_in = Date.now();
			return axios
				.get(pre + url, {
					cancelToken: new CancelToken(function executor(c) {
						cancelRequest(c);
						// c()
					}),
					headers: {
						last_log_in: localStorage.last_log_in,
						'last-log-in': localStorage.last_log_in,
						'user-group-id': localStorage.user_group_id || '',
						'x-region': localStorage.region
					}
				})
				.then((res) => {
					if (res.data.data && res.data.metadata) {
						res.data.data = utils.server_to_client_obj(res.data.data, null, res.data.metadata);
					}
					return res.data.data;
				})
				.catch((err) => {
					handleError(err);
				});
		},
		put: (url, data, config) => {
			if (!config) {
				config = axiosConfig;
			}
			if (!config.headers) {
				config.headers = {};
			}
			config.headers.last_log_in = localStorage.last_log_in;
			config.headers['user-group-id'] = localStorage.user_group_id || '';
			config.headers['last-log-in'] = localStorage.last_log_in;
			config.headers['x-region'] = localStorage.region;
			return axios
				.put(pre + url, data, config)
				.then((res) => {
					if (res.data.data && res.data.metadata) {
						res.data.data = utils.server_to_client_obj(res.data.data, null, res.data.metadata);
					}
					return res.data.data;
				})
				.catch((err) => {
					handleError(err);
				});
		},
		post: (url, data, config) => {
			data.token = localStorage.token;
			data.password_reset_guid = localStorage.password_reset_guid;
			if (!config) {
				config = axiosConfig;
			}
			if (!config.headers) {
				config.headers = {};
			}
			config.headers.last_log_in = localStorage.last_log_in;
			config.headers['user-group-id'] = localStorage.user_group_id || '';
			config.headers['last-log-in'] = localStorage.last_log_in;
			config.headers['x-region'] = localStorage.region;
			return axios
				.post(pre + url, data, config)
				.then((res) => {
					if (res.data.data && res.data.metadata) {
						res.data.data = utils.server_to_client_obj(res.data.data, null, res.data.metadata);
					}
					return res.data.data;
				})
				.catch((err) => {
					handleError(err);
				});
		},
		postReturnError: (url, data, config) => {
			data.token = localStorage.token;
			data.password_reset_guid = localStorage.password_reset_guid;
			if (!config) {
				config = axiosConfig;
			}
			if (!config.headers) {
				config.headers = {};
			}
			config.headers.last_log_in = localStorage.last_log_in;
			config.headers['user-group-id'] = localStorage.user_group_id || '';
			config.headers['last-log-in'] = localStorage.last_log_in;
			config.headers['x-region'] = localStorage.region;
			return axios
				.post(pre + url, data, config)
				.then((res) => {
					if (res.data.data && res.data.metadata) {
						res.data.data = utils.server_to_client_obj(res.data.data, null, res.data.metadata);
					}
					return res.data.data;
				})
				.catch((err) => {
					handleError(err);
					return { err };
				});
		},
		delete: (url, data, config) => {
			if (!config) {
				config = axiosConfig;
			}
			if (!config.headers) {
				config.headers = {};
			}
			config.headers['last-log-in'] = localStorage.last_log_in;
			config.headers['user-group-id'] = localStorage.user_group_id || '';
			config.headers['x-region'] = localStorage.region;
			return axios
				.delete(pre + url, data, config)
				.then((res) => {
					return res.data.data;
				})
				.catch((err) => {
					handleError(err);
				});
		}
	};
};



// WEBPACK FOOTER //
// ./src/api/requests.js